import React from "react";
import front from "../assets/anatomy/muscle-front.webp";
import backView from "../assets/anatomy/muscle-back.webp";

// Local, alpha-preserving reference-derived artwork. The SVG region layer stays
// independent so no pixels, embedded labels or image service control selection.
export default function BodyMuscleAnatomy({ back }) {
  return <g className="pc-body-map__muscles" aria-hidden="true" pointerEvents="none">
    <image href={back ? backView : front} x="0" y="0" width="320" height="480"
      preserveAspectRatio="xMidYMid meet" />
  </g>;
}
